import * as tslib_1 from "tslib";
import { SearchServiceActionTypes } from './types';
import ObjectToGetParameterMapper from '../../mapper/ObjectToGetParameterMapper';
import { settings } from '../../../settings';
var coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
export function getSearchResults(protocol, productContext, searchString, resultsPerGroupInt, availableParameter) {
    var _this = this;
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var searchObject, parameterString, searchResult, res, _a, error_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    searchObject = tslib_1.__assign({}, productContext, { q: encodeURIComponent(searchString), available: availableParameter }, (resultsPerGroupInt && { resultsPerGroup: resultsPerGroupInt }));
                    parameterString = ObjectToGetParameterMapper.map(searchObject);
                    searchResult = {
                        type: SearchServiceActionTypes.RECEIVE_SEARCH_RESPONSE,
                        searchResponse: null
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl + settings.coreApi.endPoints.search + '?'
                            + parameterString)];
                case 2:
                    res = _b.sent();
                    _a = searchResult;
                    return [4 /*yield*/, res.json()];
                case 3:
                    _a.searchResponse = (_b.sent());
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, dispatch(searchResult)];
            }
        });
    }); };
}
export function getAirportSearchResult(protocol, productContext, searchString) {
    var _this = this;
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var searchObject, parameterString, searchResult, res, _a, error_2;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    searchObject = tslib_1.__assign({}, productContext, { q: searchString });
                    parameterString = ObjectToGetParameterMapper.map(searchObject);
                    searchResult = {
                        type: SearchServiceActionTypes.RECEIVE_AIRPORT_SEARCH_RESPONSE,
                        searchResponse: null
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl +
                            settings.coreApi.endPoints.airportSearch + '?'
                            + parameterString)];
                case 2:
                    res = _b.sent();
                    _a = searchResult;
                    return [4 /*yield*/, res.json()];
                case 3:
                    _a.searchResponse = (_b.sent());
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, dispatch(searchResult)];
            }
        });
    }); };
}
